import { Outlet } from "react-router-dom";
import { MarketingNav } from "./MarketingNav";
import { MarketingFooter } from "./MarketingFooter";
import ScrollToTop from "../components/ScrollToTop";

export function MarketingLayout() {
  return (
    <div className="marketing-site marketing-scope min-h-screen bg-[#ebe8e8] font-body text-[#010101] antialiased">
      <ScrollToTop />
      <a
        href="#contenu-principal"
        className="fixed left-4 top-4 z-[100] -translate-y-[400%] rounded-lg bg-[#A43032] px-4 py-2 text-sm font-semibold text-white shadow-lg transition-transform focus:translate-y-0 focus:outline-none focus:ring-2 focus:ring-white"
      >
        Aller au contenu
      </a>
      <MarketingNav />
      <main
        id="contenu-principal"
        role="main"
        className="border-t border-[#010101]/10 bg-[linear-gradient(180deg,#f5f2f2_0%,#ebe8e8_12%,#ebe8e8_100%)]"
      >
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
}
